const GetAttendentOrdestination = (key) => {
  let AttendentOrdestination = key;
  switch (AttendentOrdestination) {
    case '1044':
   AttendentOrdestination = 'Jose Ednaldo Almeida Araujo (Ramal 1044)';
   break;

    case '1014':
      AttendentOrdestination = 'Jairton Menezes (Ramal 1014)';
      break;

    case '1001':
      AttendentOrdestination = 'Mateus Medeiros Mendes (Ramal 1001)';
      break;

    case '1003':
      AttendentOrdestination = 'Marcos Queiroz (Ramal 1003)';
      break;

    case '1048':
      AttendentOrdestination = 'Atila Bonnier de Oliveira Santo (Ramal 1048)';
      break;

    default:
      break;
  }
  return AttendentOrdestination;
};

export default GetAttendentOrdestination;
